import {
  Box,
  Button, Flex, Icon, Text, useColorModeValue,
} from '@chakra-ui/react';
import IconBox from '../Icons/IconBox';

const SideBarItem = ({ active, icon, name }) => {
  const activeBg = useColorModeValue('white', 'navy.700');
  const inactiveBg = useColorModeValue('white', 'navy.700');
  const activeColor = useColorModeValue('gray.700', 'white');
  const inactiveColor = useColorModeValue('gray.400', 'gray.400');
  const sidebarActiveShadow = '0px 7px 11px rgba(0, 0, 0, 0.04)';
  const variantChange = '0.2s linear';

  return (
    <Button
      boxSize="initial"
      justifyContent="flex-start"
      alignItems="center"
      boxShadow={active ? sidebarActiveShadow : 'none'}
      bg={active ? activeBg : 'transparent'}
      transition={variantChange}
      mb={{
        xl: '6px',
      }}
      mx={{
        xl: 'auto',
      }}
      ps={{
        sm: '10px',
        xl: '16px',
      }}
      py="12px"
      borderRadius="15px"
      hover="none"
      w="100%"
      _active={{
        bg: 'inherit',
        transform: 'none',
        borderColor: 'transparent',
      }}
      _focus={{
        boxShadow: active ? '0px 7px 11px rgba(0, 0, 0, 0.04)' : 'none',
      }}
    >
      <Flex>
        {typeof icon === 'string' ? (
          <Icon>{icon}</Icon>
        ) : (
          <IconBox
            bg={active ? 'blue.500' : inactiveBg}
            color={active ? 'white' : 'blue.500'}
            h="30px"
            w="30px"
            me="12px"
            transition={variantChange}
          >
            {icon || <Box border="2px solid" borderColor="blue.500" w="100%" height="100%" borderRadius="8px" />}
          </IconBox>
        )}
        <Text color={active ? activeColor : inactiveColor} my="auto" fontSize="sm">
          {name}
        </Text>
      </Flex>
    </Button>
  );
};

export default SideBarItem;
